import { render } from "./index.vue?vue&type=template&id=ab53b144&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ab53b144&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ab53b144"

export default script